var provider = {
	safe_color_names: [
		'черный', 'темно-бордовый', 'зеленый', 'темно-синий', 'оливковый',
		'фиолетовый', 'зеленовато-голубой', 'синий', 'серебро',
		'серый', 'желтый', 'фуксия', 'цвет морской волны', 'белый'
	],

	color_names: [
		'Военно-воздушный синий', 'Синяя Элис', 'Ализариновый красный', 'Миндаль Крайола', 'Амарантовый', 'Янтарный',
		'Американская роза', 'Аметистовый', 'Матовый белый', 'Античный белый', 'Яблочно-зеленый', 'Спаржа',
		'Цвет морской волны', 'Аквамариновый', 'Армейский зелёный', 'Мышьяковый', 'Лазурный', 'бежевый',
		'Бистр', 'Горькая радость', 'Чёрный', 'Белокурый', 'Синий', 'Вода пляжа Бонди', 'Латунный', 'Ярко-зелёный',
		'Сиена жжёная', 'Хаки', 'кардинал', 'Морковный', 'Лазурный', 'Каштановый', 'Шоколадный', 'Коричный',
		'Кобальт синий', 'Кремовый', 'Циан', 'индиго', 'Фуксия', 'Кирпичный', 'Льняной', 'Золотой', 'Зелёный',
		'Индиго', 'Нефритовый', 'Сиреневый', 'Охра', 'Панг', 'Берлинская лазурь', 'Красновато-коричневый',
		'Сангрия', 'Сепия', 'Болотный', 'Тициановый', 'Чертополох', 'Глициния', 'Вино', 'Циннвальдит',
	]
};

module.exports = provider;
